// src/pages/CourseTime/components/slides/layouts/HtmlContent/CaseStudyCard.comp.jsx
import React from 'react';
import * as S from '../../../../styles';
import { parseInlineMarkdown } from '../../../../utils';
import { getCaseStudyPart, getCaseStudySections, splitCaseStudyParagraphs } from '../../../../utils/caseStudy';
import { GET_APP_LOCALIZE_TEXT } from '../../../../../../utils/dq_lc_service/lc_service';

const renderSectionBody = (section) => {
  switch (section.kind) {
    case 'character':
      return (
        <>
          {(section.name || section.role) && (
            <p>
              {section.name && <strong>{parseInlineMarkdown(section.name)}</strong>}
              {section.name && section.role && ' — '}
              {parseInlineMarkdown(section.role)}
            </p>
          )}
          {section.goal && <p>{parseInlineMarkdown(section.goal)}</p>}
        </>
      );
    case 'choice':
      return (
        <>
          {section.question && <p>{parseInlineMarkdown(section.question)}</p>}
          {section.items.length > 0 && (
            <S.CaseStudyChoiceList>
              {section.items.map((item) => (
                <li key={item.letter}>
                  <S.CaseStudyChoiceLetter>{item.letter}.</S.CaseStudyChoiceLetter>
                  {parseInlineMarkdown(item.text)}
                </li>
              ))}
            </S.CaseStudyChoiceList>
          )}
        </>
      );
    case 'list':
      return (
        <S.CaseStudyBulletList>
          {section.items.map((item, index) => <li key={index}>{parseInlineMarkdown(item)}</li>)}
        </S.CaseStudyBulletList>
      );
    case 'numbered':
      return (
        <S.CaseStudyNumberedList>
          {section.items.map((item, index) => <li key={index}>{parseInlineMarkdown(item)}</li>)}
        </S.CaseStudyNumberedList>
      );
    default:
      return parseInlineMarkdown(section.text);
  }
};

// The `case_study` body of TemplateGraphicAndText: one card per structured
// section (case_part 1 or 2), or the legacy case_snippet split into paragraphs.
const CaseStudyCard = ({ slide, origin, pageLc }) => {
  const sections = getCaseStudySections(origin);

  if (!sections) {
    return splitCaseStudyParagraphs(origin.case_snippet || slide.SlideContent).map((paragraph, index) => (
      <S.CaseStudyParagraph key={index}>{parseInlineMarkdown(paragraph)}</S.CaseStudyParagraph>
    ));
  }

  return (
    <S.CaseStudySections $fullWidth={getCaseStudyPart(origin) === 2}>
      {sections.map((section) => (
        <S.CaseStudySection key={section.id} $fullRow={section.kind === 'numbered'}>
          <S.CaseStudySectionLabel>{GET_APP_LOCALIZE_TEXT(pageLc, section.labelKey)}</S.CaseStudySectionLabel>
          <S.CaseStudySectionBody>{renderSectionBody(section)}</S.CaseStudySectionBody>
        </S.CaseStudySection>
      ))}
    </S.CaseStudySections>
  );
};

export default CaseStudyCard;
